/**
 * Fiche de synthèse sourcée (FIC-02). Le serveur encode les grains cités en fin
 * de fiche dans un commentaire HTML `<!--GNOSIS_SOURCES:[…]-->`. On le sépare ici
 * pour afficher la fiche d'un côté et ses sources cliquables de l'autre.
 */
export interface SheetSource {
  n: number;
  id: string;
  title: string;
  excerpt: string;
}

const RE = /\n*<!--GNOSIS_SOURCES:([\s\S]*?)-->\s*$/;

export function parseSheet(raw: string | null | undefined): { md: string; sources: SheetSource[] } {
  if (!raw) return { md: '', sources: [] };
  const m = raw.match(RE);
  if (!m) return { md: raw, sources: [] };
  let sources: SheetSource[] = [];
  try {
    const parsed = JSON.parse(m[1]!);
    if (Array.isArray(parsed)) sources = parsed as SheetSource[];
  } catch {
    /* fiche sans sources exploitables */
  }
  return { md: raw.replace(RE, '').trim(), sources };
}
